import React, { useEffect, useRef } from 'react'
import JsBarcode from 'jsbarcode'

const ReportBarcode = ({ value, className = '' }) => {
  const barcodeRef = useRef(null)
  const barcodeValue = value == null ? '' : String(value).trim()

  useEffect(() => {
    if (!barcodeRef.current || !barcodeValue) return

    try {
      JsBarcode(barcodeRef.current, barcodeValue, {
        format: 'CODE128',
        width: 1.6,
        height: 30,
        displayValue: false,
        margin: 2,
        background: '#ffffff',
        lineColor: '#111827',
      })
    } catch (error) {
      console.error('Unable to render report barcode:', error)
      barcodeRef.current.replaceChildren()
    }
  }, [barcodeValue])

  if (!barcodeValue) return null

  return (
    <span className={`inline-flex shrink-0 items-center rounded bg-white py-0.5 print:border-0 print:p-0 ${className}`}>
      <svg
        ref={barcodeRef}
        role="img"
        aria-label={`Barcode ${barcodeValue}`}
        className="block h-auto max-w-[180px]"
      />
    </span>
  )
}

export default ReportBarcode
